export default __webpack_public_path__ + "static/media/SecondaryMainLogo.cf660957.svg";